<template>
	<page>
		<div class="xpage-inner">
			<h2>Authentication Error</h2>
			<p>There was an error logging you into the Loan Origination System.</p>
			<br />
			<router-link
				to="/"
				style="
					display: inline-block;
					padding: 5px 10px;
					border: 1px solid black;
					border-radius: 5px;
				"
				>Log Back In</router-link
			>
		</div>
	</page>
</template>

<script setup>
	import page from '../components/layout/Page.vue';
</script>
